import { createInput, MountTarget, newDialog, readConfig } from './utils/elements';

import '@diekeure/dcr-components/dcr-hide-copy-toggle.js';
import '@diekeure/dcr-components/dcr-divider.js';

export const COPY_EDIT_SELECTOR = '.cds-lrn-hide-copy';

interface CopyConfig {
  amount: number;
}

export function copyDialog(insertHtml: (html: string) => void, mountTarget?: MountTarget, existingEl?: HTMLElement) {
  const dialog = newDialog('Verberg / Kopieer', () => insertHtml(''), mountTarget);

  const amount = createInput('amount', 'Aantal rijen', 'number');

  if (existingEl) {
    const cfg = readConfig<CopyConfig>(existingEl, { amount: 1 });
    if (cfg.amount) amount.setValue(cfg.amount);
  }

  dialog.querySelector('#cds-dialog-content').append(amount.field);

  dialog.addEventListener('onSubmit', () => {
    const config: CopyConfig = { amount: +amount.value() };
    insertHtml(makeHideCopy(config));
  });
}

function makeHideCopy(config: CopyConfig) {
  const amount = config.amount;
  const container = document.createElement('div');
  container.style.display = 'grid';
  container.style.gridTemplateColumns = amount === 1 ? 'auto max-content 1fr' : 'max-content 1fr';
  container.classList.add('cds-lrn-hide-copy');
  container.setAttribute('data-cb-config', JSON.stringify(config));

  const toggleButton = document.createElement('dcr-hide-copy-toggle');
  toggleButton.setAttribute('state', 'on');
  toggleButton.setAttribute('aria-label', 'Verberg kolom');

  if (amount > 1) {
    toggleButton.setAttribute('multiple', '');
    toggleButton.style.textAlign = 'center';

    container.append(toggleButton, document.createElement('div'));
  }

  for (let i = 0; i < amount; i++) {
    const wordColumn = document.createElement('div');
    wordColumn.classList.add('word-column');
    wordColumn.textContent = `Word ${i + 1}`;

    const responseColumn = document.createElement('div');
    responseColumn.classList.add('response-column');
    responseColumn.textContent = `Response ${i + 1}`;

    if (amount === 1) {
      container.append(wordColumn, toggleButton, responseColumn);
    } else {
      container.append(wordColumn, responseColumn);
    }
  }

  return container.outerHTML;
}
